import React from "react";
import {
    Form, FormGroup, FormLabel, FormControl, FormSelect,
    Button, Dropdown
} from "react-bootstrap";


function generateDropdown(data) {
    return (
        data?.map((role) => 
            <option value={role}>{role}</option>
        )
    );
}

const UserForm = (props) => {
    const initialValues = props.initialValues;
    const isRegistered = props.isRegistered;
    return (
        <Form  
            onSubmit={props.onSubmit}>
            <FormGroup 
                className="mb-3" 
                controlId="firstName" >
                <FormLabel>First Name</FormLabel>
                <FormControl 
                    required 
                    type="text"
                    disabled={isRegistered}
                    placeholder={initialValues.firstName ? initialValues.firstName : "Enter first name"}/>
            </FormGroup>
            <FormGroup 
                className="mb-3" 
                controlId="lastName">
                <FormLabel>Last Name</FormLabel>
                <FormControl 
                    required 
                    type="text"
                    disabled={isRegistered}
                    placeholder={initialValues.lastName ? initialValues.lastName : "Enter last name"}/>
            </FormGroup>
            <FormGroup 
                className="mb-3" 
                controlId="role">
                <FormLabel>Role</FormLabel>
                    <FormSelect 
                        required 
                        disabled={isRegistered}
                        defaultValue={initialValues.role}>
                            <option value="">Select Role</option>
                            {generateDropdown(initialValues.roles)}
                    </FormSelect>
            </FormGroup>
            <FormGroup 
                className="mb-3" 
                controlId="unit">
                <FormLabel>Unit</FormLabel>
                    <FormSelect 
                        required 
                        disabled={isRegistered}
                        defaultValue={initialValues.unit}>
                            <option value="">Select Unit</option>
                            {generateDropdown(initialValues.units)}
                    </FormSelect>
                </FormGroup>
            <FormGroup 
                className="mb-3" 
                controlId="serial">
                <FormLabel>Serial</FormLabel>
                <FormControl 
                    disabled 
                    required
                    value={initialValues.serial}/>
            </FormGroup>
            <Button 
                variant={isRegistered ? "danger" : "info"} 
                size="lg"
                block="block" 
                type="submit">
                {isRegistered ? "Reassign Badge" : "Create User"}
            </Button>
        </Form>
    );
};

export default UserForm;
